// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"reportPage_mulitpleDropdown__14_T6","loaderWrapper":"reportPage_loaderWrapper__1v9Hf","filterMenu":"reportPage_filterMenu__1o9ux"};